"use client"

import { saveAs } from "file-saver"
import { useSelector, useDispatch } from "react-redux"
import { useState, useEffect, useRef } from "react"
import { useCountries } from "../../client/dashboard/staticData"
import { setGlobalCountries } from "../../../redux/features/countriesSlice"
// import { setGlobalCountries } from "../redux/features/countriesSlice"
// import { countries } from "../client/dashboard/staticData"

const WelcomeMessage = ({ dashboardData }) => {
  const dispatch = useDispatch()
  const globalCountries = useSelector((state) => state.globalCountries.globalCountries)
  const {
    fromMonth: savedFromMonth,
    fromYear: savedFromYear,
    toMonth: savedToMonth,
    toYear: savedToYear,
  } = useSelector((state) => state.dashboard);
  const countries = useCountries();

  // Country dropdown state
  const [isOpen, setIsOpen] = useState(false)
  const [selectedCountries, setSelectedCountries] = useState([])
  const countryDropdownRef = useRef(null)

  // Initialize selected countries from Redux store
  useEffect(() => {
    setSelectedCountries(globalCountries)
  }, [globalCountries])

  useEffect(() => {
    if (!isOpen) return

    const handleOutsideClick = (event) => {
      if (
        countryDropdownRef.current &&
        !countryDropdownRef.current.contains(event.target)
      ) {
        setIsOpen(false)
      }
    }

    document.addEventListener("mousedown", handleOutsideClick)
    document.addEventListener("touchstart", handleOutsideClick)

    return () => {
      document.removeEventListener("mousedown", handleOutsideClick)
      document.removeEventListener("touchstart", handleOutsideClick)
    }
  }, [isOpen])

  const exportToCSV = () => {
    if (!dashboardData?.stats) return

    const stats = dashboardData.stats
    const headers = ["Key", "Value"]
    const rows = []

    // Add date range
    if (savedFromMonth && savedFromYear && savedToMonth && savedToYear) {
      rows.push(["Start Month", savedFromMonth])
      rows.push(["Start Year", savedFromYear])
      rows.push(["End Month", savedToMonth])
      rows.push(["End Year", savedToYear])
    }

    // Add stats
    Object.entries(stats).forEach(([key, value]) => {
      rows.push([key, value])
    })

    // Add global countries if they exist
    if (globalCountries && globalCountries.length > 0) {
      const countryNames = globalCountries.map((c) => c.name || c).join(" | ")
      rows.push(["Global Countries", countryNames])
    }

    const csvContent = [headers.join(","), ...rows.map((r) => r.join(","))].join("\n")
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })

    saveAs(blob, "dashboard-stats.csv")
  }

  const handleCheckboxChange = (countryName) => {
    setSelectedCountries((prevSelected) => {
      const updatedSelection = prevSelected.includes(countryName)
        ? prevSelected.filter((name) => name !== countryName)
        : [...prevSelected, countryName]
      dispatch(setGlobalCountries(updatedSelection))
      setIsOpen(false)
      return updatedSelection
    })
  }

  return (
    <div className="flex flex-col gap-4">
      {/* Header with greeting and export button */}
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-y-5 md:gap-y-0">
        <h1 className="text-base font-medium md:text-xl lg:text-2xl flex flex-row">
          <span>
            Hi Admin!&nbsp;
          </span>
          <span className="hidden md:block">Let's get started for the day</span>
        </h1>

        <button
          onClick={exportToCSV}
          className="flex items-center justify-center px-4 py-2 text-sm md:text-base bg-[#87CA60] text-black rounded-full hover:bg-[#6fbf50] transition-colors duration-200"
        >
          Export CSV
        </button>
      </div>

      {/* Country Dropdown */}
      <div className="flex md:hidden justify-start">
        <div ref={countryDropdownRef} className="relative">
          <button
            onClick={() => setIsOpen(!isOpen)}
            className="flex items-center space-x-2 rounded-full p-1.5 md:p-2 text-sm border border-[#87CA60]/60 bg-white drop-shadow-md text-black w-fit justify-between"
          >
            <div className="flex items-center space-x-2">
              {selectedCountries.length > 0 ? (
                <>
                  <div className="flex items-center space-x-1">
                    {selectedCountries.length <= 8 &&
                      selectedCountries.map((name) => {
                        const country = countries.find((c) => c.name === name)
                        return country ? (
                          <img
                            key={country.name}
                            src={country.flag || "/placeholder.svg"}
                            alt={country.name}
                            className="w-6 h-6 rounded-full object-cover border border-slate-300"
                          />
                        ) : null
                      })}
                  </div>
                  {selectedCountries.length > 8 && (
                    <span className="text-sm text-gray-600">+{selectedCountries.length - 8} more</span>
                  )}
                </>
              ) : (
                <span className="text-gray-500">Select countries</span>
              )}
            </div>

            <svg
              className={`w-4 h-4 transition-transform ${isOpen ? "rotate-180" : ""}`}
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
            </svg>
          </button>

          {isOpen && (
            <div className="absolute left-0 mt-2 w-[250px] bg-white border rounded-lg shadow-lg py-1 z-10 max-h-60 overflow-y-auto">
              {countries.map((country) => (
                <label
                  key={country.name}
                  className="w-full flex items-center px-4 py-2 text-sm cursor-pointer hover:bg-gray-100 space-x-2"
                >
                  <input
                    type="checkbox"
                    checked={selectedCountries.includes(country.name)}
                    onChange={() => handleCheckboxChange(country.name)}
                    className="cursor-pointer"
                  />
                  <img
                    src={country.flag || "/placeholder.svg"}
                    alt={country.name}
                    loading="lazy"
                    className="w-5 h-5 rounded-full object-cover"
                  />
                  <span className="text-black">{country.name}</span>
                </label>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* Selected Countries Summary */}
      {/* {selectedCountries.length > 0 && (
        <div className="text-sm text-gray-600">
          Selected {selectedCountries.length} countr{selectedCountries.length === 1 ? "y" : "ies"}
        </div>
      )} */}
    </div>
  )
}

export default WelcomeMessage
